/**
 * 获取path
 * @param path
 * @param base
 */
export function getPath (path: string, base: any) {
  return '/' + base.path + '/' + path
}
